import React, { useEffect, useState } from "react";
import Header from "../Header";
import Loader from "../Utils/Loader";

function CarthiInsurance(props) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // <script defer data-active  data-widget-type="group"
    //                     data-person="312d796b-a3b2-4ee9-ad83-9de5f767dec4" src="https://whatsapp.pcubeweb.com/install-widget/bundle.js?key=65e7e2ad-97b0-4755-9cef-59e23cea9889"></script><div data-active id="whatapp-people-widget-312d796b-a3b2-4ee9-ad83-9de5f767dec4"></div>
    const script = document.createElement("script");
    script.src =
      "https://whatsapp.pcubeweb.com/install-widget/bundle.js?key=65e7e2ad-97b0-4755-9cef-59e23cea9889";
    script.defer = true;
    script.setAttribute("data-active", "");
    script.setAttribute("data-widget-type", "group");
    script.setAttribute("data-person", "312d796b-a3b2-4ee9-ad83-9de5f767dec4");
    document.body.appendChild(script);
    setLoading(false);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <div>
      <Header />
      {loading && <Loader />}
      <div
        data-active
        id="whatapp-people-widget-312d796b-a3b2-4ee9-ad83-9de5f767dec4"
      ></div>
    </div>
  );
}

export default CarthiInsurance;
